import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

const WHITE_LIST_URLS = [
  "/watch/",
  "/niches/",
  "/users/",
  "/gifs/",
];

export const useResetSearchTag = () => {
  const location = useLocation();
  const setSearchTag = useAnalyticsStore((state) => state.setSearchTag);

  useEffect(() => {
    for (const url of WHITE_LIST_URLS) {
      if (location.pathname.startsWith(url)) {
        return;
      }
    }

    setSearchTag(null);
  }, [location]);
};
